/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Day_FriInputs */

const en_ui_day_fri = /** @type {(inputs: Ui_Day_FriInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fri`)
};

const de_ui_day_fri = /** @type {(inputs: Ui_Day_FriInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fr`)
};

/**
* | output |
* | --- |
* | "Fri" |
*
* @param {Ui_Day_FriInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_day_fri = /** @type {((inputs?: Ui_Day_FriInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Day_FriInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_day_fri(inputs)
	return de_ui_day_fri(inputs)
});